import React from "react";
import { TriangleAlert } from "lucide-react";

/**
 * RejectionNotice — the engine's refusal of a save, drawn next to the controls
 * that caused it (ARC-54).
 *
 * One component so both save surfaces state a rejection identically: the risk
 * card and the allocation editor. It is deliberately NOT the tab-level banner —
 * that one stays as the backstop and is composed in StrategyAutomationTab.
 *
 * `keys` is the list of setting names the engine didn't recognise. Naming them
 * is the point: it turns an app/engine version mismatch into something the
 * member can report precisely instead of "saving is broken".
 */
const RejectionNotice = ({ rejection, testId }) => {
  if (!rejection) return null;
  const keys = Array.isArray(rejection.keys) ? rejection.keys : [];

  return (
    <div
      role="alert"
      data-testid={testId}
      className="flex items-start gap-2.5 rounded-arc-ctl bg-arc-neg-soft ring-1 ring-arc-neg/40 p-3"
    >
      <TriangleAlert size={15} className="text-arc-neg flex-shrink-0 mt-0.5" aria-hidden="true" />
      <div className="text-caption text-arc-neg leading-relaxed">
        <p className="m-0">{rejection.message}</p>
        {keys.length > 0 && (
          <p className="mt-1 m-0">
            Rejected {keys.length === 1 ? "key" : "keys"}:{" "}
            <span className="font-mono">{keys.join(", ")}</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default RejectionNotice;
